import { createActionRoute, createSiteRoute } from '@townsquare/router/create-route';

export const followGoalActionRoute = createSiteRoute(
	createActionRoute({
		exact: true,
		name: 'followGoalAction',
		path: '/goal/:key/:action(follow|unfollow)',
	}),
);
